import React from "react";

import { SEK_OIS_CURVE_DEFINITION_ID } from "./constants";
import { FoNavCurve } from "./FoNavCurve";

interface FoNavOisProps {
    startDate: string;
    endDate: string;
}

export function FoNavOis({ startDate, endDate }: FoNavOisProps): React.ReactElement {
    return (
        <FoNavCurve
            curveDefinitionId={SEK_OIS_CURVE_DEFINITION_ID}
            header="SEK-OIS"
            loadingLabel="SEK-OIS"
            startDate={startDate}
            endDate={endDate}
        />
    );
}
